module.exports = __webpack_public_path__ + "img/5.187fb559.jpg";